module.exports = __webpack_public_path__ + "static/media/34DSS4.6960c6ed.jpg";